<template>
  <div class="bg-[#F0FBFB]">
    <div
      class="flex flex-col md:flex-row flex-wrap w-full md:mx-auto md:max-w-screen-lg gap-6"
    >
      <div class="p-0 md:p-6 md:my-6">
        <AuthWindow />
      </div>

      <div
        class="md:max-w-[25rem] md:mx-auto px-4 md:pt-5 text-[#213756F2] flex-1 grid grid-rows-[auto_auto_1fr]"
      >
        <div class="flex flex-row items-center gap-3 pt-10 pb-3">
          <ClipboardIcon
            class="w-[2.5em] h-[2em] -ml-1 align-middle text-secondary"
          />
          <BaseTypography variant="h2" class="text-lg font-semibold">
            {{ $t("pages.account.auth_container.title") }}
          </BaseTypography>
        </div>
        <BaseTypography disable-ellipsis class="pb-8">
          <i18n-t keypath="pages.account.auth_container.description" scope="global">
            <template #link>
              <a :href="resultsUrl" target="_blank" class="underline text-secondary hover:no-underline">{{
                $t("pages.account.auth_container.patient_area") }}</a>
            </template>
          </i18n-t>
        </BaseTypography>

        <svg
          id="Group_1325"
          data-name="Group 1325"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 239.995 161.089"
          class="md:w-full lg:w-screen max-w-[24rem] md:translate-x-[35%] mt-auto"
        >
          <defs>
            <linearGradient
              id="linear-gradient"
              y1="-18.703"
              x2="1"
              y2="-18.703"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#2b233c" />
              <stop offset="1" stop-color="#635c70" />
            </linearGradient>
            <linearGradient
              id="linear-gradient-2"
              x1="0"
              y1="-23.482"
              x2="1"
              y2="-23.482"
              xlink:href="#linear-gradient"
            />
            <linearGradient
              id="linear-gradient-3"
              x1="-12.505"
              y1="-7.917"
              x2="-12.498"
              y2="-7.917"
              gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#232e4a" />
              <stop offset="1" />
            </linearGradient>
          </defs>
          <g
            id="Group_1321"
            data-name="Group 1321"
            transform="translate(0 3.809)"
            opacity="0.17"
            style="mix-blend-mode: normal; isolation: isolate"
          >
            <path
              id="Path_4720"
              data-name="Path 4720"
              d="M1264.393,565.894c61.331-119.72,72.229-123.352,83.992-132.837a86.337,86.337,0,0,1,21.42-12.483c.881-.37,1.784-.73,2.714-1.094a158.77,158.77,0,0,1,27.972-7.868,139.914,139.914,0,0,1,16.7-2.1,100.194,100.194,0,0,1,30.924,2.5,69.857,69.857,0,0,1,22.18,9.827,64.133,64.133,0,0,1,6.356,4.917,74.5,74.5,0,0,1,17.969,24.309c14.392,30.329,13.513,73.476-6.9,113.577-1.115.009-2.222.013-3.337.022h0q-9.34.07-18.687.133-8.485.051-16.97.111-18.278.125-36.551.244-5.537.041-11.073.077-17.983.125-35.968.243-14.35.093-28.7.194-9.626.06-19.253.126-7.648.052-15.3.1"
              transform="translate(-1264.393 -409.258)"
              fill="#00a1aa"
              opacity="0.39"
              style="mix-blend-mode: normal; isolation: isolate"
            />
            <g
              id="Group_1320"
              data-name="Group 1320"
              transform="translate(49.832)"
              opacity="0.96"
              style="mix-blend-mode: normal; isolation: isolate"
            >
              <path
                id="Path_4721"
                data-name="Path 4721"
                d="M1518.914,567.848q-18.062.12-36.129.24l4.692-144.883c.885-.37,1.791-.733,2.726-1.1a160.632,160.632,0,0,1,28.1-7.867l.612,153.607Z"
                transform="translate(-1429.986 -411.882)"
                fill="#267476"
                opacity="0.52"
                style="mix-blend-mode: normal; isolation: isolate"
              />
              <path
                id="Path_4722"
                data-name="Path 4722"
                d="M1407.123,591.43q-18.062.12-36.128.24l3.259-92.4s0-2.921,12.039-22.1c2.107-2.915,10.949-13.985,20.218-19.282l.612,133.546Z"
                transform="translate(-1370.995 -434.914)"
                fill="#267476"
                opacity="0.54"
                style="mix-blend-mode: normal; isolation: isolate"
              />
              <path
                id="Path_4723"
                data-name="Path 4723"
                d="M1619.542,564.887q-18.359.12-36.713.243l5.042-155.636a100.99,100.99,0,0,1,31.062,2.5Z"
                transform="translate(-1482.778 -409.247)"
                fill="#267476"
                opacity="0.52"
                style="mix-blend-mode: normal; isolation: isolate"
              />
            </g>
          </g>
          <g
            id="Group_1322"
            data-name="Group 1322"
            transform="translate(63.609)"
          >
            <path
              id="Path_4724"
              data-name="Path 4724"
              d="M1483.842,287.752a4.356,4.356,0,0,0-4.355-4.37h-99.373a4.4,4.4,0,0,0-4.379,4.37v64.125a4.4,4.4,0,0,0,4.379,4.37h99.373a4.356,4.356,0,0,0,4.355-4.37Z"
              transform="translate(-1375.735 -283.382)"
              fill="#00a1aa"
            />
            <path
              id="Path_4725"
              data-name="Path 4725"
              d="M1453.789,449.126a1.684,1.684,0,0,0-1.686-1.688H1425.8a1.7,1.7,0,0,0-1.686,1.688h0a1.693,1.693,0,0,0,1.686,1.686H1452.1a1.68,1.68,0,0,0,1.686-1.684h0Z"
              transform="translate(-1407.124 -389.827)"
              fill="#fff"
            />
            <path
              id="Path_4726"
              data-name="Path 4726"
              d="M1458.257,387.2a2.109,2.109,0,0,0-.617-1.494,2.137,2.137,0,0,0-1.5-.637h-29.9a2.15,2.15,0,0,0-1.52.637,2.108,2.108,0,0,0-.617,1.494v13.956a2.115,2.115,0,0,0,2.137,2.115h29.9a2.115,2.115,0,0,0,2.115-2.115Z"
              transform="translate(-1407.115 -349.359)"
              fill="#f7f9f9"
            />
            <path
              id="Path_4727"
              data-name="Path 4727"
              d="M1540.451,316.108a1.683,1.683,0,0,0-1.686-1.688H1512.46a1.7,1.7,0,0,0-1.686,1.688h0a1.693,1.693,0,0,0,1.686,1.686h26.305a1.68,1.68,0,0,0,1.686-1.684h0Z"
              transform="translate(-1463.353 -303.52)"
              fill="#f7f9f9"
            />
            <path
              id="Path_4728"
              data-name="Path 4728"
              d="M1542.08,447.444a1.7,1.7,0,0,0-1.686,1.688h0a1.693,1.693,0,0,0,1.686,1.686h26.306a1.68,1.68,0,0,0,1.686-1.684h0a1.684,1.684,0,0,0-1.686-1.691"
              transform="translate(-1482.571 -389.831)"
              fill="#fff"
            />
            <path
              id="Path_4729"
              data-name="Path 4729"
              d="M1441.334,466.208a1.683,1.683,0,0,0-1.682-1.688h-13.885a1.69,1.69,0,0,0-1.693,1.688h0a1.689,1.689,0,0,0,1.693,1.686h13.885a1.677,1.677,0,0,0,1.682-1.684h0Z"
              transform="translate(-1407.099 -400.91)"
              fill="#d8ddff"
            />
            <path
              id="Path_4730"
              data-name="Path 4730"
              d="M1528,333.19a1.682,1.682,0,0,0-1.681-1.688h-13.885a1.69,1.69,0,0,0-1.692,1.688h0a1.688,1.688,0,0,0,1.692,1.686h13.885a1.677,1.677,0,0,0,1.681-1.684h0Z"
              transform="translate(-1463.329 -314.604)"
              fill="#d8ddff"
            />
            <path
              id="Path_4731"
              data-name="Path 4731"
              d="M1425.268,321.385a3.386,3.386,0,0,0,.853.137h.853c.394.026.394.2.394.383a.412.412,0,0,1-.394.5c-.723,0-1.576.181-2.034-.245-.066-.038-.132-.081-.132-.135,0-.033-.066-.071-.066-.108a.438.438,0,0,1,.524-.531Zm6.17.139c.395.086.527.835-.066.877H1429.6c-.461-.031-.723-.835,0-.881h1.771A.268.268,0,0,0,1431.439,321.524Zm4.4,0c.395.088.524.837-.066.877H1434c-.46-.031-.723-.835,0-.881h1.772A.267.267,0,0,0,1435.837,321.524Zm4.4-.066c.461.108.525.773-.132.892a3.348,3.348,0,0,1-.59.051H1438.4c-.328-.02-.328-.141-.394-.271a.437.437,0,0,1,.394-.611,8.318,8.318,0,0,0,1.642-.057s0-.028.2,0Zm2.363-3.255c.59.11.46,1.141.262,1.725a1.367,1.367,0,0,1-.328.672c-.2.357-.985.068-.657-.6a3.056,3.056,0,0,0,.262-1.086v-.274c0-.368.2-.454.458-.436Zm-19.494-.282c.328.061.394.194.394.436v.591a2.473,2.473,0,0,0,.2.965.716.716,0,0,1-.066.489c-.262.238-.656.112-.787-.35a3.206,3.206,0,0,1-.2-1.093V318.3c.066-.225.132-.4.46-.379ZM1442.6,313.8c.262.042.394.137.394.437V316c0,.456-.853.69-.853,0v-1.763A.393.393,0,0,1,1442.6,313.8Zm-19.494-.282c.328.062.394.194.394.436v1.763c-.066.8-.853.467-.853,0V313.95a.394.394,0,0,1,.46-.436Zm19.494-4.125c.262.042.394.137.394.436v1.763c0,.447-.853.69-.853,0v-1.763C1442.14,309.457,1442.336,309.371,1442.6,309.389Zm-19.494-.282c.328.062.394.194.394.436v1.763c0,.4-.2.412-.394.437a.447.447,0,0,1-.46-.437v-1.763A.394.394,0,0,1,1423.1,309.106Zm18.969-5.148c.262.033.394.238.525.463a3.418,3.418,0,0,1,.394,1.6v1.216c-.066.438-.853.564-.853-.058a4.233,4.233,0,0,0-.46-2.534s-.2-.692.394-.688Zm-18.771.756c.394.1.262.386.2,1.318v.866c0,.463-.853.661-.853,0v-.877a1.889,1.889,0,0,1,.132-.848c.066-.254.2-.494.525-.458Zm3.413-2.133a.44.44,0,0,1-.066.877,3.813,3.813,0,0,0-1.51.2.559.559,0,0,1-.46-.051c-.262-.216-.2-.668.328-.84a3.241,3.241,0,0,1,1.115-.189h.524c.066,0,.066,0,.066,0Zm12.865,0c1.181.024.786.937.262.9,0,0-.2-.018-.328-.02h-1.379c-.262-.018-.328-.093-.394-.22a.477.477,0,0,1,.394-.661c.461,0,.919,0,1.443,0Zm-4.07,0c.461.088.591.838,0,.877h-1.772c-.458-.031-.723-.835,0-.881h1.772Zm-4.4,0a.44.44,0,0,1-.066.877h-1.706c-.46-.031-.657-.84,0-.881h1.706C1431.113,302.577,1431.113,302.579,1431.113,302.581Z"
              transform="translate(-1406.171 -295.836)"
              fill="#fff"
            />
            <path
              id="Path_4732"
              data-name="Path 4732"
              d="M1445,323.538v-2.343c0-.09,0-.1.022-.143a.4.4,0,0,1,.419-.258.382.382,0,0,1,.353.4v2.336c.793,0,1.609,0,2.4.028.353.04.33.13.375.357a.431.431,0,0,1-.419.447H1445.8v2.362c0,.3-.088.293-.221.359a.4.4,0,0,1-.573-.359v-2.362h-2.38c-.418-.015-.573-.785,0-.807C1443.417,323.557,1444.21,323.546,1445,323.538Z"
              transform="translate(-1418.892 -307.655)"
              fill="#fff"
            />
          </g>
          <g
            id="Group_1323"
            data-name="Group 1323"
            transform="translate(97.161 35.793)"
          >
            <circle
              id="Ellipse_158"
              data-name="Ellipse 158"
              cx="1.578"
              cy="1.578"
              r="1.578"
              transform="translate(26.087 0)"
              fill="#d9daec"
            />
            <circle
              id="Ellipse_159"
              data-name="Ellipse 159"
              cx="1.578"
              cy="1.578"
              r="1.578"
              transform="translate(26.087 7.393)"
              fill="#d9daec"
            />
            <circle
              id="Ellipse_160"
              data-name="Ellipse 160"
              cx="1.578"
              cy="1.578"
              r="1.578"
              transform="translate(26.087 14.785)"
              fill="#d9daec"
            />
            <circle
              id="Ellipse_161"
              data-name="Ellipse 161"
              cx="1.578"
              cy="1.578"
              r="1.578"
              transform="translate(19.567 0)"
              fill="#d9daec"
            />
            <circle
              id="Ellipse_162"
              data-name="Ellipse 162"
              cx="1.578"
              cy="1.578"
              r="1.578"
              transform="translate(19.567 7.393)"
              fill="#d9daec"
            />
            <circle
              id="Ellipse_163"
              data-name="Ellipse 163"
              cx="1.578"
              cy="1.578"
              r="1.578"
              transform="translate(19.567 14.785)"
              fill="#d9daec"
            />
            <circle
              id="Ellipse_164"
              data-name="Ellipse 164"
              cx="1.578"
              cy="1.578"
              r="1.578"
              transform="translate(13.044 0)"
              fill="#d9daec"
            />
            <circle
              id="Ellipse_165"
              data-name="Ellipse 165"
              cx="1.578"
              cy="1.578"
              r="1.578"
              transform="translate(13.044 7.393)"
              fill="#d9daec"
            />
            <circle
              id="Ellipse_166"
              data-name="Ellipse 166"
              cx="1.578"
              cy="1.578"
              r="1.578"
              transform="translate(13.044 14.785)"
              fill="#d9daec"
            />
            <circle
              id="Ellipse_167"
              data-name="Ellipse 167"
              cx="1.578"
              cy="1.578"
              r="1.578"
              transform="translate(6.523 0)"
              fill="#d9daec"
            />
            <circle
              id="Ellipse_168"
              data-name="Ellipse 168"
              cx="1.578"
              cy="1.578"
              r="1.578"
              transform="translate(6.523 7.393)"
              fill="#d9daec"
            />
            <circle
              id="Ellipse_169"
              data-name="Ellipse 169"
              cx="1.578"
              cy="1.578"
              r="1.578"
              transform="translate(6.523 14.785)"
              fill="#d9daec"
            />
            <circle
              id="Ellipse_170"
              data-name="Ellipse 170"
              cx="1.578"
              cy="1.578"
              r="1.578"
              fill="#d9daec"
            />
            <circle
              id="Ellipse_171"
              data-name="Ellipse 171"
              cx="1.578"
              cy="1.578"
              r="1.578"
              transform="translate(0 7.393)"
              fill="#d9daec"
            />
            <circle
              id="Ellipse_172"
              data-name="Ellipse 172"
              cx="1.578"
              cy="1.578"
              r="1.578"
              transform="translate(0 14.785)"
              fill="#d9daec"
            />
          </g>
          <g
            id="Group_1324"
            data-name="Group 1324"
            transform="translate(17.127 10.069)"
          >
            <path
              id="Path_4733"
              data-name="Path 4733"
              d="M1300.092,386.846s4.837-4.16,6.807-6.155a28.931,28.931,0,0,0,4.9-7.42c1.433-2.874,2.173-.63,2.329.937.135,1.567-.873,3.211-.247,3.947.65.738,2.016,1.3,2.418,2.151.425.851-2.329,2.138-3.27,2.744a6.988,6.988,0,0,1,.269,2.389c-.178.906-4.277,5.789-5.172,6.871-.919,1.082-8.486-2.523-8.531-3.522a4.107,4.107,0,0,1,.492-1.939Z"
              transform="translate(-1279.335 -350.875)"
              fill="#f7f9f9"
            />
            <path
              id="Path_4734"
              data-name="Path 4734"
              d="M1322.69,379.8a31.293,31.293,0,0,0,4.1-6.536c1.432-2.874,2.173-.63,2.329.937.135,1.567-.873,3.211-.247,3.947.65.739,2.016,1.3,2.417,2.151.426.838-2.261,2.1-3.224,2.713l-.044.029s-.895-2.4-2.283-3.032a6.006,6.006,0,0,0-3.046-.209Z"
              transform="translate(-1294.319 -350.871)"
              fill="#f6926a"
            />
            <path
              id="Path_4735"
              data-name="Path 4735"
              d="M1348.316,314.471a2.442,2.442,0,0,0-.7-1.71,2.486,2.486,0,0,0-1.728-.708h-19.939a2.434,2.434,0,0,0-2.426,2.417v19.952a2.374,2.374,0,0,0,.718,1.708,2.407,2.407,0,0,0,1.708.709h19.939a2.47,2.47,0,0,0,1.728-.709,2.432,2.432,0,0,0,.7-1.708V314.471Z"
              transform="translate(-1294.861 -312.054)"
              fill="#ececec"
            />
            <circle
              id="Ellipse_173"
              data-name="Ellipse 173"
              cx="3.171"
              cy="3.171"
              r="3.171"
              transform="translate(37.886 6.091)"
              fill="#00a1aa"
            />
            <path
              id="Path_4736"
              data-name="Path 4736"
              d="M1339.336,357.222a1.661,1.661,0,0,1-1.362-2.618,8.655,8.655,0,0,1,14.24.006,1.688,1.688,0,0,1,.117,1.712,1.67,1.67,0,0,1-1.479.891c-3.131.009-8.383.009-11.517.009Z"
              transform="translate(-1304.04 -337.241)"
              fill="#00a1aa"
            />
            <path
              id="Path_4737"
              data-name="Path 4737"
              d="M1370.284,379.6a2,2,0,0,0,.313-1.939c-.381-1.2-1.1-2.867-.112-3.544s2.329.78,3.136-1.163,2.061-3.852,4.075-3.522,2.755,3.438,1.188,6.091a22.056,22.056,0,0,0-1.97,4.969c-.335.59-6.629-.891-6.629-.891Z"
              transform="translate(-1325.007 -349.257)"
              fill="#f6926a"
            />
            <path
              id="Path_4738"
              data-name="Path 4738"
              d="M1315.155,395.6a6.539,6.539,0,0,1,.178.784,16.876,16.876,0,0,1-7.5,3.522,7.179,7.179,0,0,1-4.972-1.1c1.41-1.212,4.634-4.039,6.157-5.58.269-.287.56-.584.807-.895v.009a6.038,6.038,0,0,1,3.046.21c1.388.628,2.283,3.032,2.283,3.032v.015Zm.044-.048-.022.006h.022Zm.044-.027-.022.007.022,0h0Zm.044-.037v.009h0Zm.066-.031-.022.011v-.007l.022-.006Zm.09-.051h0l-.066.037.022-.011.044-.024Zm-5.575-3.108-.022.007.044-.033-.022.026Zm.066-.086-.022.026.022-.035v.009Zm.044-.044-.022.011.022-.033v.022Zm.066-.088-.044.04.044-.046v.007Zm.022-.044v.013l.022-.035-.022.02Zm.09-.093c-.022.018-.022.033-.044.051Zm.022-.04v.02l.022-.037Zm.091-.093c-.022.018-.044.035-.044.053Zm.022-.042-.022.024.044-.04-.022.015Zm.066-.09c0,.018-.022.035-.044.055Zm.044-.044-.022.033.022-.046v.013Zm.022-.046v.013l.044-.051Zm.09-.1c-.022.02-.022.037-.044.057Zm.022-.035v.018l.022-.051Zm.09-.1c-.022.02-.044.04-.044.059Zm.022-.038-.022.024.044-.053-.022.029Zm.066-.1c-.022.02-.022.042-.044.062Z"
              transform="translate(-1281.453 -363.554)"
              fill="#f7f9f9"
            />
            <path
              id="Path_4739"
              data-name="Path 4739"
              d="M1268.375,387.373s1.163-3.339-.515-5.361c-1.7-2.023-5.219-5.569-1.479-9.69s8.083-4.07,10.7-.231c2.6,3.839,3.605,8.215,2.576,9.357-1.053,1.139-2.576,2.171-1.142,5.368.941,2.093-10.144.56-10.144.56Z"
              transform="translate(-1256.708 -349.146)"
              fill="#f58b60"
            />
            <path
              id="Path_4740"
              data-name="Path 4740"
              d="M1275.149,398.7c2.217-1.7,6.316-4.736,6.56-4.961.313-.3.447-.227.873.663s1.479,2.763,2.777,2.094a5.258,5.258,0,0,0,1.454-1.043v.112h0v.474l-.022.022v.2l-.022.028v.124l-.022.026v.09l-.022.018v.033h0v.051l-.022.009v.051l-.022.024h0v.058l-.022.015v.053h0l-.022.022v.031l-.022.013v.029l-.022.02h0v.027l-.022.013v.027l-.022.013v.024h0l-.022.018v.024l-.022.011v.024l-.022.018h0l-.022.018v.022l-.022.011v.015l-.022,0v.015c-.225.236-.448.467-.672.714a14.513,14.513,0,0,0-2.755,1.252,3.221,3.221,0,0,0-1.77,2.71l-3.515,1.369c-1.479-.04-2.576-.119-2.576-.119v-.009h0v-.024a.035.035,0,0,1,.022-.028h0v-.046h0v0h0v-.009l.022-.02v-.053l.022-.013V402.9l.022,0v-.044h0c0-.018.022-.035.022-.053h0v-.058l.022-.015v-.079l.022-.015v-.079l.022-.015v-.071a.062.062,0,0,0,.022-.057h0v-.035l.022-.024v0h0v-.073c0-.02.022-.04.022-.06h0v-.035h0v-.04h0v-.011l.022-.025V402l.022-.009v-.073h0v-.046l.022-.035h0V401.7l.022-.011v-.095h0v-.046h0v-.015l.022-.024V401.3h0c0-.018.022-.033.022-.049h0v-.361h0v-.022l.022-.024v-.229h0v-.053h0v-.02l-.022-.026v-.236h0v-.1h0v-.027l-.022-.022v-.192h0a.17.17,0,0,1-.022-.1h0v-.046h0c0-.018-.022-.035-.022-.051h0v-.1h0a.052.052,0,0,1-.022-.048h0c0-.051-.022-.1-.022-.145h0a.049.049,0,0,0-.022-.048h0c0-.048-.022-.1-.022-.143h0c0-.018-.022-.033-.022-.048h0c0-.033-.022-.064-.022-.1h0c0-.016-.022-.031-.022-.046h0v-.024h0c-.022-.042-.022-.079-.044-.119h0V398.9h0l-.022-.015v-.009h0a.341.341,0,0,0-.044-.141h0v-.013l-.022-.011h0v-.024Z"
              transform="translate(-1263.461 -365.095)"
              fill="#ed6c36"
            />
            <path
              id="Path_4741"
              data-name="Path 4741"
              d="M1266.382,366.538a.183.183,0,0,0,.022-.106c.516-3.229,4.143-7.094,6.069-5.871a3.615,3.615,0,0,1,1.723,3.288v.088a13.552,13.552,0,0,1-1.1,2.536c.516.69,1.792,2.708.785,2.823s-2.8.824-1.7,2.283a2.237,2.237,0,0,0,2.821.522c.628,2.724.469,4.736-1.813,4.908a19.952,19.952,0,0,0-4.525.983h0a4.107,4.107,0,0,0-.806-1.747c-1.7-2.023-5.219-5.569-1.479-9.69v-.015Z"
              transform="translate(-1256.708 -343.377)"
              fill="#0c0739"
            />
            <path
              id="Path_4742"
              data-name="Path 4742"
              d="M1259.192,705.787s1.479.434.516,2.79-1.9,5.39-2.127,5.979c-.2.588,8.486,1.115,9.249,2.314,1.142,1.8-13.121,2.078-17.175,2.036-3.158-.033-7.658.328-6.338-1.721a94.048,94.048,0,0,0,4.568-9.672c.626-1.631,11.307-1.721,11.307-1.721Z"
              transform="translate(-1242.666 -568.239)"
              fill="url(#linear-gradient)"
            />
            <path
              id="Path_4743"
              data-name="Path 4743"
              d="M1370.082,713.345c.672,2.175,1.21,3.876,1.545,4.943,1.254,3.766,8.039,3.682,10.39,5.6l-20.959.086-3.427-10.148,12.451-.478Z"
              transform="translate(-1316.99 -573.142)"
              fill="url(#linear-gradient-2)"
            />
            <path
              id="Path_4744"
              data-name="Path 4744"
              d="M1255.449,497.709s-3.717-.981-3.18,5.423a167.716,167.716,0,0,0,3.918,24.8c2.127,8.313,4.143,13.083.76,19.426s-13.7,20.428-15.047,24.1c1.053,2,14.465.868,17,.965,0,0,6.181-11.559,8.89-14.756s6.741-9.542,6.583-17.065-6.9-37.445-6.9-37.445-7.12-11.3-12.025-5.456Z"
              transform="translate(-1241.901 -432.143)"
              fill="url(#linear-gradient-3)"
            />
            <path
              id="Path_4745"
              data-name="Path 4745"
              d="M1321.76,579.818l-.926.035-11.523.443-2.935.146s-4.791-18.811-6.651-25-3.716-15.673-4.725-20.873c-1.029-5.2-6.56-11.2-8.934-16.834a40.491,40.491,0,0,1-2.911-9.892l14.457-.159,2.607-.028s1.1-.723,2.261,1.609,4.815,13.978,8.777,31.493c3.158,14.011,7.861,30.352,10.5,39.061Z"
              transform="translate(-1268.668 -439.617)"
              fill="#232e4a"
            />
            <path
              id="Path_4746"
              data-name="Path 4746"
              d="M1348.47,579.818l-.926.035c-3.749-2.818-6.788-9.2-7.561-14.727-.941-6.571-3.314-13.907-5.753-20.34-2.464-6.431-5.532-16.065-6.517-23.646a68.892,68.892,0,0,0-3.391-13.456l2.607-.028s1.1-.723,2.261,1.609,4.815,13.978,8.777,31.493c3.158,14.011,7.861,30.352,10.5,39.06Z"
              transform="translate(-1295.378 -439.617)"
              fill="#3b4766"
            />
            <path
              id="Path_4747"
              data-name="Path 4747"
              d="M1255.013,423.329s-3.671,2.439-5.71.244-1.188-7.536.335-11.684c1.545-4.147,4.412-8.03,9.2-8.87s10.7-.705,17.824,4.963,6.807,6.633,8.083,3.387,4.95-13.674,5.487-14.831c.56-1.157,3.089-1.761,5.575-1.388,2.464.37,3.27.681,2.933,2.528-.313,1.844-3.671,19.809-6.763,24.2s-7.568,5.525-10.838,3.211-7.48-5.694-7.48-5.694,2.261,4.491,3.314,7.224,2.083,4.5,1.9,5.965a6.476,6.476,0,0,0,.851,3.656l-23.535,1.08a32.193,32.193,0,0,0-1.03-5.293c-.65-1.869-.2-7.656-.156-8.694Z"
              transform="translate(-1245.923 -366.09)"
              fill="#f7f9f9"
            />
            <path
              id="Path_4748"
              data-name="Path 4748"
              d="M1307.423,469.219s-3.718-8.015-4.994-11.794c-1.3-3.779-1.589-4.586-3.561-7.067s-3.493-6.9.179-3.561c3.515,3.191,5.688,4.762,6.741,5.8-.335-.254-.516-.4-.516-.4s2.261,4.491,3.314,7.224,2.083,4.5,1.9,5.965a6.471,6.471,0,0,0,.851,3.656l-3.918.181Z"
              transform="translate(-1277.529 -398.964)"
              fill="#dbdddd"
            />
            <path
              id="Path_4749"
              data-name="Path 4749"
              d="M1292.106,416.739c3.762.155,8.083,1.439,12.964,5.324,6.27,4.989,6.763,6.333,7.658,4.37a1.024,1.024,0,0,1,.022.685c-.941,2.362-1.679,3.367-4.681.992a102.8,102.8,0,0,0-14-8.422c-2.464-1.219-2.4-2.3-1.97-2.949Z"
              transform="translate(-1274.326 -380.167)"
              fill="#dbdddd"
            />
            <path
              id="Path_4750"
              data-name="Path 4750"
              d="M1364.118,395.249a9.493,9.493,0,0,1,3.381-.091c2.463.371,3.27.681,2.933,2.528-.313,1.845-3.672,19.809-6.763,24.2a10.446,10.446,0,0,1-4.881,3.965c-.985-2.314,1.836-5.245,3.874-9.516,2.4-5.055,1.882-9.621,1.232-14.254a21.051,21.051,0,0,1,.225-6.829Z"
              transform="translate(-1317.609 -366.078)"
              fill="#dbdddd"
            />
            <path
              id="Path_4751"
              data-name="Path 4751"
              d="M1249.992,454.8a.314.314,0,0,1,.2-.04c.894.1,3.068-1.922,3.7-5.1.6-3.173,2.173-6.629,2.127-4.8-.022,1.831.178,8.852.2,10.216v.254c-.247.165-3.718,2.347-5.688.236a4.147,4.147,0,0,1-.538-.773Z"
              transform="translate(-1247.149 -398.139)"
              fill="#dbdddd"
            />
          </g>
          <g
            id="Group_701"
            data-name="Group 701"
            transform="translate(166.328 72.146)"
          >
            <path
              id="Path_624"
              data-name="Path 624"
              d="M1619.16,621.194l10.065-6.47a33.223,33.223,0,0,0,5.414-12.9,34.478,34.478,0,0,0,.4-3.684l-4.245.09,4.224-4.111A48.242,48.242,0,0,0,1633,583.294a49.366,49.366,0,0,0-6-13.143,130.7,130.7,0,0,0-12.9,12.288c-.135.157-.27.292-.4.449l.539,5.841-2.38-3.707c-4.224,5.055-7.863,10.649-9.683,16.962a33.712,33.712,0,0,0-.9,4.111l4.381,9.1-4.785-2.18c.268,7.773,2.786,15.434,6.111,22.534,4.224-2.539,14.176-11.39,16.8-14.131.877-.9,1.707-1.842,2.516-2.809l-7.144,2.584Z"
              transform="translate(-1573.845 -566.512)"
              fill="#00a1aa"
            />
            <line
              id="Line_172"
              data-name="Line 172"
              y1="46.572"
              x2="14.513"
              transform="translate(33.228 22.556)"
              fill="none"
              stroke="#fff"
              stroke-width="1"
              opacity="0.36"
              style="mix-blend-mode: normal; isolation: isolate"
            />
            <path
              id="Path_625"
              data-name="Path 625"
              d="M1594.277,613.231l7.145-9.593a33.331,33.331,0,0,0,.517-13.974,28.09,28.09,0,0,0-.921-3.595l-3.954,1.573,2.494-5.325a52.335,52.335,0,0,0-15.951-19.59,128.456,128.456,0,0,0-7.728,16.041,5.869,5.869,0,0,1-.225.562l2.562,5.278-3.527-2.629c-2.18,6.223-3.617,12.738-3.078,19.275a31.345,31.345,0,0,0,.607,4.156l7.3,6.965-5.235-.359c2.988,7.166,8.066,13.457,13.659,18.939,3.055-3.863,9.255-15.659,10.739-19.141.494-1.147.943-2.337,1.37-3.527l-5.775,4.943Z"
              transform="translate(-1558.87 -562.727)"
              fill="#5cc2c9"
            />
            <line
              id="Line_173"
              data-name="Line 173"
              x1="2.853"
              y1="48.706"
              transform="translate(26.353 19.591)"
              fill="none"
              stroke="#fff"
              stroke-width="1"
              opacity="0.36"
              style="mix-blend-mode: normal; isolation: isolate"
            />
            <path
              id="Path_626"
              data-name="Path 626"
              d="M1558.84,633.884l-8.29-5.324a25.529,25.529,0,0,1-4.808-13.66l3.5.068-3.482-3.392a43.108,43.108,0,0,1,6.6-19.747A107.719,107.719,0,0,1,1563,601.96c.113.112.224.247.337.382l-.427,4.808,1.955-3.056a38.793,38.793,0,0,1,7.975,13.974,29.468,29.468,0,0,1,.742,3.392l-3.617,7.5,3.931-1.8c-.224,6.4-2.314,12.716-5.032,18.557-3.483-2.09-11.683-9.392-13.863-11.637-.719-.741-1.415-1.528-2.065-2.314l5.909,2.112Z"
              transform="translate(-1545.742 -577.561)"
              fill="#00a1aa"
            />
            <line
              id="Line_174"
              data-name="Line 174"
              x1="11.952"
              y1="38.395"
              transform="translate(11.098 29.835)"
              fill="none"
              stroke="#fff"
              stroke-width="1"
              opacity="0.36"
              style="mix-blend-mode: normal; isolation: isolate"
            />
            <path
              id="Path_627"
              data-name="Path 627"
              d="M1603.684,687.191l-2.719,27.926h-22.511l-2.7-27.926Z"
              transform="translate(-1561.043 -626.173)"
              fill="#141449"
            />
            <path
              id="Path_628"
              data-name="Path 628"
              d="M1610.926,687.191l-2.719,27.926h-15.524l-2.719-27.926Z"
              transform="translate(-1568.285 -626.173)"
              fill="#267476"
            />
            <path
              id="Path_629"
              data-name="Path 629"
              d="M1585.441,715.116h-6.987l-2.7-27.926h6.965Z"
              transform="translate(-1561.043 -626.173)"
              opacity="0.91"
              style="mix-blend-mode: normal; isolation: isolate"
            />
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ClipboardIcon from "~/components/icons/Clipboard.vue";
import AuthWindow from "./auth-window.vue";

const testResults = useTestResults();
const resultsUrl = testResults.resultsUrl;
</script>
